import classNames from 'classnames';
import React, { ComponentProps } from 'react';
import { SwiperSlide } from 'swiper/react';
import { space } from '@moda/tokens';
import ChevronLeftIcon from '@moda/icons/chevron-left-60';
import ChevronRightIcon from '@moda/icons/chevron-right-60';
import { Swiper } from '../Swiper';

import './SwiperCarousel.scss';

const SMALL_SIZE = 6;
const CHEVRON_SIZE = space.scale[SMALL_SIZE];

export type SwiperCarouselProps = ComponentProps<typeof Swiper> & {
  className?: string;
  classNameNavigation?: string;
  classNameWrapper?: string;
  identifier: string;
};

export const SwiperCarousel: React.FC<SwiperCarouselProps> = ({
  children,
  className,
  classNameNavigation,
  classNameWrapper,
  identifier,
  ...rest
}) => {
  if (React.Children.count(children) === 0) return null;

  return (
    <div
      key={React.Children.count(children)}
      className={classNames('SwiperCarousel__wrapper', classNameWrapper)}
      id={identifier}
    >
      <Swiper
        centerInsufficientSlides
        className={classNames('SwiperCarousel', className)}
        containerModifierClass="SwiperCarousel--"
        navigation={{
          prevEl: `#${identifier} .SwiperCarousel__prev`,
          nextEl: `#${identifier} .SwiperCarousel__next`,
          disabledClass: 'SwiperCarousel__navigation--disabled'
        }}
        pagination={{
          modifierClass: 'SwiperCarousel__pagination--',
          type: 'bullets',
          clickable: true,
          hideOnClick: false,
          bulletClass: 'SwiperCarousel__bullet',
          bulletActiveClass: 'SwiperCarousel__bullet--active'
        }}
        preloadImages={false}
        speed={500}
        {...rest}
      >
        {React.Children.map(children, (child, index) => (
          <SwiperSlide
            className="SwiperCarousel__slide"
            key={React.isValidElement(child) ? child.key : index}
          >
            {child}
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={classNames('SwiperCarousel__prev', classNameNavigation)}>
        <ChevronLeftIcon width={CHEVRON_SIZE} height={CHEVRON_SIZE} />
      </div>

      <div className={classNames('SwiperCarousel__next', classNameNavigation)}>
        <ChevronRightIcon width={CHEVRON_SIZE} height={CHEVRON_SIZE} />
      </div>
    </div>
  );
};
